import * as actionTypes from './action-types';
import { ItemType, ProductType } from 'components/ProductsSelection/types';
import { FilterSelectionType } from '../types';

export const applySelectionWithValues = (currentMenu: ProductType, values: Array<ItemType>) => {
  return {
    type: actionTypes.APPLY_VALUES,
    payload: { currentMenu, values },
  };
};

export const setTransientValues = (currentMenu: ProductType, values: Array<ItemType>) => {
  return {
    type: actionTypes.SET_TRANSIENT_VALUES,
    payload: { currentMenu, transients: values },
  };
};

export const clearSelections = () => {
  return { type: actionTypes.CLEAR_SELECTIONS };
};

export const initValues = (values: FilterSelectionType) => ({
  type: actionTypes.INIT_VALUES,
  payload: values,
});

export const storesForMappingLoading = () => ({
  type: actionTypes.STORES_FOR_MAPPING_LOADING,
});

export const itemsForMappingLoading = () => ({
  type: actionTypes.PRODUCTS_FOR_MAPPING_LOADING,
});
